import type { Schemas } from '@argzombie/api-client';

/*
 * The health intake content section (`healthRules`, shared-cs `Content/HealthRulesDef.cs`, health intake CONTRACT §7). The generated
 * leaf types, with the nested blocks nullable so a draft's explicit `null`s validate like the server. `intensityMin`/`intensityMax`
 * are C# read-only getters the server serializes; the editor neither shows nor needs them.
 */
export type HealthHrBandsDef = Schemas['HealthHrBandsDef'];
export type HealthBoundsDef = Schemas['HealthBoundsDef'];
export type HealthBandsDef = Schemas['HealthBandsDef'];
export type HealthLevelsDef = Schemas['HealthLevelsDef'];
export type HealthTrustedSourceDef = {
  id?: string | null;
  platform?: string | null;
  tier?: number;
};
export type HealthRulesDef = Omit<
  Schemas['HealthRulesDef'],
  | 'hrBands'
  | 'bounds'
  | 'bands'
  | 'levels'
  | 'trustedSources'
  | 'tierCredit'
  | 'intensityClamp'
  | 'mets'
> & {
  tierCredit?: number[] | null;
  intensityClamp?: number[] | null;
  mets?: Record<string, number> | null;
  hrBands?: HealthHrBandsDef | null;
  bounds?: HealthBoundsDef | null;
  bands?: HealthBandsDef | null;
  levels?: HealthLevelsDef | null;
  trustedSources?: (HealthTrustedSourceDef | null)[] | null;
};

/** shared-cs `HealthPlatforms.All`. */
export const HEALTH_PLATFORMS = ['ios', 'android'] as const;
/** shared-cs `ActivityCategories.All`, in index order (the index is the `cat` fact of `health.workout`). */
export const ACTIVITY_CATEGORIES = [
  'walk',
  'run',
  'cycle',
  'hike',
  'strength',
  'hiit',
  'swim',
  'sport',
  'other',
] as const;
/** shared-cs `WorkoutTiers`: 0..3, 4 values. */
export const WORKOUT_TIERS = { min: 0, max: 3, count: 4 } as const;
